import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import InsertReferenceUI from './insertreferenceui';


export default class InsertReference extends Plugin {
  static get pluginName() {
    return 'InsertReference';
  }

  static get requires() {
    return [InsertReferenceUI];
  }
}
